import React from 'react';
import PropTypes from 'prop-types';

import { KlarnaLogoFull, Typography } from '@klarna/bubble-ui';
import KustomLogoSVG from '../../static/kustom.svg';

const styles = {
  container: { display: 'flex', alignItems: 'center', lineHeight: '26px' },
  klarnaLogoContainer: ({ pink, isKustom }) => ({
    backgroundColor: isKustom ? 'transparent' : pink ? '#FFB3C7' : '#000000',
    borderRadius: 4,
    padding: '5px 3px',
    marginRight: '5px',
    height: '26px',
    display: 'flex',
    alignItems: 'center',
  }),
  klarnaLogo: ({ pink }) => ({
    surfaceSize: {
      fill: !pink ? 'white' : null,
      transform: 'scale(0.7654)',
      width: 65,
      height: 16,
    },
    rootStyle: { transform: 'scale(0.8)' },
  }),
  kustomLogo: { width: 65, height: 26, verticalAlign: 'middle' },
};

const ProductHead = ({ productId, productName }) => {
  const isKustom = productId.startsWith('kco');

  return (
    <div style={styles.container}>
      <div style={styles.klarnaLogoContainer({ pink: productId.startsWith('kp'), isKustom })}>
        {isKustom ? (
          <img src={KustomLogoSVG} alt="Kustom Logo" style={styles.kustomLogo} />
        ) : (
          <KlarnaLogoFull styleSheet={styles.klarnaLogo({ pink: productId.startsWith('kp') })} />
        )}
      </div>
      <Typography textToken="text-style/text/labels/tall/bold">{productName}</Typography>
    </div>
  );
};

ProductHead.propTypes = {
  productId: PropTypes.string,
  productName: PropTypes.string,
};

ProductHead.defaultProps = {
  productId: '',
  productName: '',
};

export default ProductHead;
